import { route } from 'preact-router';
import { appAlert, appConfirm } from './dialogs';
import { beginDialogAction } from './dialogAction';

// Helpers for cross-customer sales visibility (featureFlags.sharedSales).
// Clinic groups share one data pool across several sibling customers (the
// "Dine kunder" list). Visitors/animals/journals are membership-scoped and
// open in place — a sale belongs to exactly ONE company, so opening a
// foreign sale is the only action that switches the active customer.

function sharedSalesEnabled(userStore) {
    const { customer = {}, user = {} } = userStore || {};
    const { featureFlags = {} } = customer;
    const { customerIds } = user;
    return !!featureFlags.sharedSales && Array.isArray(customerIds) && customerIds.length > 1;
}

function isForeignSale(sale, userStore) {
    const activeId = userStore?.customer?.id;
    return !!(sale && sale.customer > 0 && activeId > 0 && sale.customer !== activeId);
}

function saleCompanyName(sale, userStore) {
    const { currentCustomers = [] } = userStore || {};
    const company = currentCustomers.find(c => c.id === sale?.customer);
    return company?.name || '';
}

async function switchToSaleCustomerAndOpen({ stores, sale }) {
    const { userStore, saleStore, journalStore, visitorStore, animalStore, calendarStore } = stores;
    const dialogAction = beginDialogAction(userStore, 'switchToSaleCustomerAndOpen', () => [
        sale.id,
        sale.customer,
    ]);
    if (!dialogAction) return false;
    try {
        const { id, customer } = sale;
        const name = saleCompanyName(sale, userStore) || `firma ${sale.customer}`;
        if (!(await appConfirm(`Dette salget tilhører ${name}. Bytte firma og åpne salget?`)) || !dialogAction.isCurrent()) {
            return false;
        }
        // Save BEFORE clearAll: if the save fails, the UI is left intact instead
        // of already-cleared stores pointing at a company we never switched to.
        const saveResponse = await userStore.save({ customer });
        if (!saveResponse || saveResponse.status >= 300) {
            (await appAlert(`Kunne ikke bytte firma til ${name}. Prøv igjen.`));
            return false;
        }
        // Same sequence as the "Dine kunder" switcher in menu/index.js.
        [saleStore, journalStore, visitorStore, animalStore, calendarStore].forEach(s => s?.clearAll?.());
        await userStore.getInfo({ forceLoad: true });
        if (userStore.customer?.id !== customer) {
            (await appAlert(`Kunne ikke bytte firma til ${name}. Prøv igjen.`));
            return false;
        }
        route(`/dyrejournal-sale/${id}`);
        return true;
    } finally {
        dialogAction.finish();
    }
}

export {
    sharedSalesEnabled,
    isForeignSale,
    saleCompanyName,
    switchToSaleCustomerAndOpen,
};
